import * as THREE from 'three';
import LineloopsRepresentation2d from '../representation2d/LineloopsRepresentation2d';
import { sceneUnitsFromMm } from '../../utils/scaler';
import { LineSegments2 } from 'three/addons/lines/LineSegments2.js';
import { LineSegmentsGeometry } from 'three/addons/lines/LineSegmentsGeometry.js';
import { LineMaterial } from 'three/addons/lines/LineMaterial.js';

 const EDGE_Z_OFFSET = sceneUnitsFromMm(1.1);
const FILL_Z_OFFSET = sceneUnitsFromMm(1);

export default class LineloopsGeometry2d {

    private static edgeMaterial = new LineMaterial({ color: 0x696969, linewidth: 1, dashed: false, name: 'Lineloops-Edge' });

    private static fillMaterial = new THREE.MeshBasicMaterial({ color: 'white', name: 'Lineloops-Fill' });

    static create(lineloops: LineloopsRepresentation2d, layer: number, position: THREE.Vector3): THREE.Group {
        const group = new THREE.Group();
        
        const loopPosition = position.clone().setZ(position.z + EDGE_Z_OFFSET);
        const fillPosition = position.clone().setZ(position.z + FILL_Z_OFFSET)

        const layers = new THREE.Layers();
        layers.set(layer);

        // Fills
        lineloops.fills.forEach(fill => {
             const fillPoints = fill.map((v: any) => new THREE.Vector2(v.x, v.y));
             if (fillPoints.length > 3) {
                 const shape = new THREE.Shape(fillPoints);
                 const geometry = new THREE.ShapeGeometry(shape);
                 const mesh = new THREE.Mesh(geometry, LineloopsGeometry2d.fillMaterial);
                 mesh.layers.set(layer);
                 mesh.position.copy(fillPosition);
                 group.add(mesh);
             }
        });

        // Edges
        lineloops.lineloops.forEach(loop => {
             const lsg = new LineSegmentsGeometry();
             const flatPositions: number[] = [];
             for (let i = 0; i < loop.length - 1; i++) {
                 const p1 = loop[i];
                 const p2 = loop[(i + 1)]; 
                 flatPositions.push(p1.x, p1.y, p1.z, p2.x, p2.y, p2.z);
             }
             lsg.setPositions(flatPositions);
             const line = new LineSegments2(lsg, LineloopsGeometry2d.edgeMaterial);
             line.layers.set(layer);
             line.position.copy(loopPosition);
             group.add(line);
        });

        return group;
    }
}
